var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralAnatomy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 102",
    style: {
      enableBackground: "new 0 0 103 102"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{clip-path:url(#SVGID_00000145777812316878052740000002642594938902195880_);}\n\t.st3{fill:#E86E7B;}\n\t.st4{fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;}\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.5,
    y: 0,
    width: 102,
    height: 102
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000027587126811757062500000001772690235405873290_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000027587126811757062500000001772690235405873290_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M98.2,93.5h-85c-1.1,0-2.2-0.4-3-1.2c-0.8-0.8-1.2-1.9-1.2-3v-85c0-1.1-0.4-2.2-1.2-3C7,0.4,5.9,0,4.8,0 s-2.2,0.4-3,1.2C0.9,2,0.5,3.1,0.5,4.2v85c0,3.4,1.3,6.6,3.7,9s5.6,3.7,9,3.7h85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3 s-0.4-2.2-1.2-3C100.5,93.9,99.4,93.5,98.2,93.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.3,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2S60,49.9,60,51v29.8c0,1.1,0.4,2.2,1.2,3C62,84.6,63.1,85,64.3,85z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2s-2.2,0.4-3,1.2 S26,49.9,26,51v29.8c0,1.1,0.4,2.2,1.2,3C28,84.6,29.1,85,30.2,85z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C79,84.6,80.1,85,81.2,85z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C45,84.6,46.1,85,47.2,85z"
  })))))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M51.7,27.1c4.8,0,8.8-3.9,8.8-8.6c0-4.8-3.9-8.6-8.8-8.6c-4.8,0-8.8,3.9-8.8,8.6C43,23.2,46.9,27.1,51.7,27.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M53.4,64l2.5,22.5c0,1,0.4,2.1,1.2,2.8c0.8,0.7,1.8,1.2,2.8,1.2c0.5,0,1.1-0.1,1.5-0.3c0.5-0.2,0.9-0.5,1.3-0.9 c0.4-0.4,0.7-0.8,0.9-1.3c0.2-0.5,0.3-1,0.3-1.5l-2.5-40l12.7,5.8c0.9,0.5,2,0.5,3,0.2c1-0.3,1.8-1,2.3-1.9l0.2-0.4 c0.2-0.5,0.4-1,0.4-1.5c0-0.5,0-1-0.2-1.5c-0.2-0.5-0.4-1-0.8-1.4c-0.4-0.4-0.8-0.7-1.3-1l-19-9.1c-2.4-1.1-5-1.7-7.6-1.7 c-2.6,0-5.2,0.6-7.6,1.7l-19,9.1c-0.5,0.2-0.9,0.6-1.3,1s-0.6,0.8-0.8,1.4c-0.2,0.5-0.2,1-0.2,1.5c0,0.5,0.2,1,0.4,1.5l0.2,0.4 c0.5,0.9,1.3,1.6,2.3,1.9c1,0.3,2.1,0.3,3-0.2l12.6-5.8l-2.5,40c0,0.5,0.1,1,0.3,1.5c0.2,0.5,0.5,0.9,0.9,1.3 c0.4,0.4,0.8,0.7,1.3,0.9c0.5,0.2,1,0.3,1.5,0.3c0.5,0,1.1-0.1,1.5-0.3c0.5-0.2,0.9-0.5,1.3-0.8c0.4-0.4,0.7-0.8,0.9-1.3 c0.2-0.5,0.3-1,0.3-1.5L48.9,64L53.4,64z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralAnatomy);
export default __webpack_public_path__ + "static/media/generalAnatomy.4788024a8cc22643c3f97ff6e552d108.svg";
export { ForwardRef as ReactComponent };